import { Dispatch, SetStateAction } from "react"
import { Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { SelectedMainUserState } from "../../../createOrderTypes"
import { canOverrideClosingDates } from "../../../helpers"
import { useCreateOrderDialogType } from "../../../hooks/useCreateOrderDialogType"
import { MeetingServiceConfig, DynamicConfigKey } from "../../form/formTypes"
import { UserType } from "../../../../../../modules/login/loginTypes"

import { DeliveryTimeSelector } from "../delivery/DeliveryTimeSelector"
import { ActionButtons } from "./ActionButtons"
import { ShopFiltersTypes } from "../ShopList"

const useStyles = makeStyles()((theme) => ({
    container: {
        padding: "1.25rem 1rem 1.5rem",
        background: theme.palette.common.white,
    },
}))

type ShopListHeaderProps = Readonly<{
    filters: ShopFiltersTypes
    setFilters: Dispatch<SetStateAction<ShopFiltersTypes>>
    meetingServiceConfiguration?: MeetingServiceConfig
    handleCloseMainDialog: () => void
    userType: SelectedMainUserState["userType"]
}>

export function ShopListHeader({
    filters,
    setFilters,
    meetingServiceConfiguration,
    handleCloseMainDialog,
    userType,
}: ShopListHeaderProps) {
    const { classes } = useStyles()
    const { isRegularOrder } = useCreateOrderDialogType()

    const findProductWish = meetingServiceConfiguration?.sections
        .flatMap(({ groups }) => groups.flatMap(({ fields }) => fields))
        .find((field) => field.key === DynamicConfigKey.PRODUCT_WISH)?.active

    return (
        <Stack
            direction={{ xs: "column", sm: "row" }}
            alignItems={{ xs: "stretch", sm: "center" }}
            gap=".75rem"
            flexWrap="nowrap"
            justifyContent="space-between"
            className={classes.container}
        >
            {meetingServiceConfiguration && (
                <DeliveryTimeSelector
                    meetingServiceConfiguration={meetingServiceConfiguration}
                    handleCloseMainDialog={handleCloseMainDialog}
                    disabled={!isRegularOrder}
                    allowOutsideBusinessHours={userType === UserType.MERCHANT}
                    canOverrideClosingDates={canOverrideClosingDates(userType)}
                    allowPastDates={
                        userType === UserType.SUPPORT ||
                        userType === UserType.MERCHANT ||
                        userType === UserType.SUPPLIER
                    }
                />
            )}
            <ActionButtons filters={filters} setFilters={setFilters} isProductWish={!!findProductWish} />
        </Stack>
    )
}
